/**
 * External dependencies
 */
import React, { memo } from 'react';
import PageView from '@naruto/naruto-components/src/layer/v1/PageView';
/**
 * Internal dependencies
 */
import useMappedRoute from '@naruto/bgdcms/src/hooks/useMappedRoute';
import SideBar from './SideBar';
import useData from './useData';

function MainView(): React.ReactElement {
  /* Global & local State */
  const dom = useMappedRoute([]);
  const { showSidebar } = useData();

  /* Main */
  return (
    <PageView headerHeight={0} side={showSidebar && <SideBar />}>
      {dom}
    </PageView>
  );
}

export default memo(MainView);
